import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JobShareService {
private job: any = null;
  private uuid: string | null = null;
  private userId: number | null = null;
constructor() { }
  setJob(job: any) { this.job = job; }
  getJob(): any { return this.job; }

  // 🔹 User UUID Methods
  setUserUuid(uuid: string) {
    this.uuid = uuid;
  }

  getUserUuid(): string | null {
    return this.uuid;
  }

  // 🔹 User ID Methods
  setUserId(id: number) {
    this.userId = id;
  }

  getUserId(): number | null {
    return this.userId;
  }
 
}
